export enum PlanPeriod {
    Monthly,
    Yearly,
    Quarterly,
    None = 99
}